export default __webpack_public_path__ + "static/media/bg11.d5f06869.svg";